<template>
    <div class="results-list-load-more" v-if="moreResultsAvailable">
        <button type="button" class="btn btn--inverse" v-on:click="nextPage()">
            View more
        </button>
    </div>
</template>

<script>
    export default {
        computed: {
            moreResultsAvailable() {
                return this.$store.state.search.results.length < this.$store.state.search.resultCount
            }
        },

        data() {
            return { }
        },

        methods: {
            nextPage: function () {
                const currentPage = this.$store.state.search.filters.page
                const totalResults = this.$store.state.search.results.length
                const totalAvailableResults = this.$store.state.search.resultCount

                if (totalResults < totalAvailableResults) {
                    this.$store.dispatch('updateSearchFilter', { key: 'page', value: currentPage + 1 })
                    this.$eventHub.$emit('search-pageChanged')
                } else {
                    console.log('No more results available.')
                }
            }
        }
    }
</script>